import { useCallback, useState } from "react";

export const LOADING_SECTION = "LOADING_SECTION";
export const LOADING_BUTTON = "LOADING_BUTTON";
const useLoading = (props) => {
  const [{ loading, loadingType }, setLoading] = useState({
    loading: false,
    loadingType: LOADING_SECTION,
    ...props,
  });
  const toggleLoading = useCallback(() => {
    setLoading((current) => ({ ...current, loading: !loading }));
  }, [loading]);
  const startLoading = useCallback(async (type = LOADING_SECTION) => {
    await setLoading((current) => {
      return {
        ...current,
        loading: true,
        loadingType: type,
      };
    });
  }, []);
  const stopLoading = useCallback(async (type = LOADING_SECTION) => {
    await setLoading((current) => {
      return {
        ...current,
        loading: false,
        loadingType: type,
      };
    });
  }, []);
  const setLoadingHandle = useCallback(
    (isLoading) =>
      setLoading((current) => ({ ...current, loading: isLoading })),
    []
  );
  return {
    loading,
    toggleLoading,
    startLoading,
    stopLoading,
    loadingType,
    setLoading: setLoadingHandle,
  };
};
export default useLoading;
